import 'core-js/es6';
import 'core-js/es7/reflect';
require('zone.js/dist/zone');
if (process.env.ENV === 'production') {
}
else {
    // Development
    Error['stackTraceLimit'] = Infinity;
    require('zone.js/dist/long-stack-trace-zone');
}
import { platformBrowser } from '@angular/platform-browser';
import { AppModuleNgFactory } from '../aot/src/app/app.module.ngfactory';
import { enableProdMode } from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
if (process.env.ENV === 'production') {
    enableProdMode();
}
platformBrowser().bootstrapModuleFactory(AppModuleNgFactory).catch(function (err) { return console.error(err); });
// load app styles
require('./index.less');
require('./i18n/en.json');
require('./i18n/fr.json');
require('./i18n/pt.json');
require('./i18n/de.json');
require('./i18n/es.json');
require('./i18n/it.json');
require('./i18n/nl.json');
require('./i18n/ach.json');
require('./web.config');
//# sourceMappingURL=main-aot.js.map


//////////////////
// WEBPACK FOOTER
// ./src/main-aot.js
// module id = 829
// module chunks = 0